import jsonExport from "jsonexport/dist";
import { downloadCSV } from "react-admin";
import { DataProvider, getListParamsFromHash } from "./helpers/exporterUtils";

export const partnerExporter = async (
  _records: any[],
  _fetchRelatedRecords: any,
  dataProvider: DataProvider,
  resource: string
) => {
  const { sort, filter } = getListParamsFromHash({
    sortField: "ts",
    sortOrder: "DESC",
  });

  const response = await dataProvider.getList(resource, {
    pagination: { page: 1, perPage: 100000 },
    sort,
    filter,
  });

  const records = response.data as any[]; // array of partners/sessions
  const flatRows: any[] = [];

  records.forEach((rec) => {
    const baseRow = { ...rec };
    const answers = Array.isArray(rec.answers) ? rec.answers : [];

    // Format ts field if present (RFC 1123)
    if (baseRow.ts) {
      const tsValue = Number(baseRow.ts);
      const dateObj = tsValue > 1e12 ? new Date(tsValue) : new Date(tsValue * 1000);
      baseRow.ts = dateObj.toUTCString();
    }

    delete baseRow.answers; // remove answers from base row

    if (answers.length) {
      answers.forEach((ans: any) => {
        const row = {
          ...baseRow,
          ...ans,
          id: rec.id, // keep computed id
        };
        // Format ts field in answer if present (RFC 1123)
        if (row.ts) {
          const tsValue = Number(row.ts);
          const dateObj = tsValue > 1e12 ? new Date(tsValue) : new Date(tsValue * 1000);
          row.ts = dateObj.toUTCString();
        }
        flatRows.push(row);
      });
    } else {
      flatRows.push(baseRow);
    }
  });

  let headers = Array.from(new Set(flatRows.flatMap((r) => Object.keys(r))));
  // Replace 'ts' header with 'timestamp'
  headers = headers.map(h => h === 'ts' ? 'timestamp' : h);

  const fileName = resource.trim().replace(/(\.csv)+$/i, "");
  // Also rename 'ts' key to 'timestamp' in each row
  const exportRows = flatRows.map(row => {
    if ('ts' in row) {
      row['timestamp'] = row.ts;
      delete row.ts;
    }
    return row;
  });
  jsonExport(exportRows, { headers, rowDelimiter: "," }, (err: any, csv: string) => {
    if (err) console.error(err);
    else downloadCSV(csv, fileName);
  });
};